import { memo } from 'react';

import { AudioSampleRatesSelect } from '~/components/Filters/AudioSampleRateFilter/components/AudioSampleRatesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePrivateAudioSampleRatesList } from '~/swr-hooks/filters/usePrivateAudioSampleRatesList';

type PrivateAudioSampleRatesSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateAudioSampleRatesSelect = memo(
  ({ boardId, libraryId, ...props }: PrivateAudioSampleRatesSelectProps) => {
    const { data = [], isLoading } = usePrivateAudioSampleRatesList({
      boardId,
      libraryId,
    });

    return <AudioSampleRatesSelect isLoading={isLoading} audioRates={data} {...props} />;
  },
);

PrivateAudioSampleRatesSelect.displayName = 'PrivateAudioSampleRatesSelect';
